module.exports = __webpack_public_path__ + "static/img/1901_1.aa51dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1901_1.jpg
// module id = YmGf
// module chunks = 1